import React from 'react';

import PropTypes from 'prop-types';
import { Select } from 'semantic-ui-react';

import { capitalizeAll } from 'libs/strings';

import { STATUS, STATUS_UNREVIEWED } from './StatusSelector.constants';

import './StatusSelector.scss';

const propTypes = {
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function StatusSelector({ onChange }) {
  function handleDropdownChange(event, { value }) {
    onChange(value);
  }

  const dropdownOptions = STATUS.map((status) => ({
    key: status,
    text: capitalizeAll(status),
    value: status,
  }));

  return (
    <Select
      selection
      options={dropdownOptions}
      onChange={handleDropdownChange}
      placeholder="Filter by Status"
      defaultValue={STATUS_UNREVIEWED}
    />
  );
}

StatusSelector.propTypes = propTypes;
StatusSelector.defaultProps = defaultProps;
